var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    transform: "rotate(180 11 11)",
    fill: "white",
    stroke: "url(#paint0_linear_1108_766)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1108_766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.88945 10.6915L9.6418 5.64987C9.73633 5.54961 9.89101 5.50091 9.99414 5.50091C10.1083 5.50091 10.223 5.5403 10.3138 5.61996C10.5078 5.79006 10.5222 6.08001 10.3459 6.26707L6.31601 10.5426L17.1244 10.5426C17.3871 10.5426 17.5996 10.7475 17.5996 10.9751C17.5996 11.2027 17.387 11.4592 17.1244 11.4592L6.3163 11.4592L10.3468 15.7361C10.5231 15.9232 10.5088 16.2133 10.3147 16.3832C10.1203 16.5524 9.82003 16.5398 9.643 16.3518L4.89066 11.3102C4.72617 11.1355 4.72617 10.8663 4.88945 10.6915Z",
    fill: "#363636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1108_766",
    x1: 1.66371e-7,
    y1: 10.45,
    x2: 22,
    y2: 10.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3192B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#4DBA78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#7EB76A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#C8A734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45959"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1108_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8333,
    height: 14.6667,
    fill: "white",
    transform: "translate(17.5996 18.334) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.9873f391666961ff6eae5c47e2e15e2c.svg";
export { ForwardRef as ReactComponent };